import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row, Form } from "react-bootstrap";
import { AppLayout } from "../../layouts";
import { actionCommon, actionDoctor } from "../../redux/actions";
import {
  Buttton,
  Header,
  Inputs,
  Modaal,
  SelectO,
  Sides,
  Tabbles,
} from "../../components";
import { MdOutlineMedicalServices } from "react-icons/md";
import { FiEdit } from "react-icons/fi";
import { PiTrash } from "react-icons/pi";
import { TbInfoTriangleFilled } from "react-icons/tb";
import { useAlert, useModal, useSnackBar, useToast } from "../../contexts";

const MyFees = ({ loginData }) => {
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const { showToast } = useToast();
  const { showModal, hideModal } = useModal();
  const { showSnackBar } = useSnackBar();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedDoctor, setSelectedDoctor] = useState([]);
  const [credentials, setCredentials] = useState({
    userGuid: loginData.userGuid,
    feesGuid: "",
    currencyId: null,
    onlineAppointmentFees: null,
    refundPercentage: null,
    inClinicAppointmentFees: null,
    refundInClinicPercentage: null,
    isChatFree: false,
    chatFees: null,
    acceptOnlinePayment: false,
    isAutomaticBookingApproval: false,
    currency: "",
    currencyCode: "",
    commission: 0,
    IsClinicDoctorFees: loginData.userGuid !== selectedDoctor?.value,
    oldCurrencyId: null,
  });
  // console.log("credentials", credentials);

  const [errors, setErrors] = useState({});

  useEffect(() => {
    setCredentials((prev) => ({
      ...prev,
      IsClinicDoctorFees: loginData.userGuid !== selectedDoctor?.value,
    }));
  }, [loginData.userGuid, selectedDoctor]);

  const handleDecimalChange = (e) => {
    const { name, value } = e.target;

    if (/^\d*\.?\d*$/.test(value)) {
      const numericValue = value === "" ? null : parseFloat(value);

      setCredentials((prevCredentials) => ({
        ...prevCredentials,
        [name]: numericValue,
      }));
    }
  };

  const handleSelectChange = (selected) => {
    setSelectedDoctor(selected);
    if (selected && selected.value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        physicianServiceIds: "",
      }));
    }

    setCredentials((prevCredentials) => ({
      ...prevCredentials,
      userGuid: selected.value,
      ClinicGuid: loginData.clinicGuid,
      IsClinicDoctorFees: true,
    }));
  };

  const handleSelectChange1 = (name, selected) => {
    setCredentials((prevCredentials) => ({
      ...prevCredentials,
      [name]: selected.value,
      currency: selected.label,
      currencyCode: selected.currencyCode,
    }));
    setSelectedCurrency1(selected);
    setErrors((prevErrors) => ({
      ...prevErrors,
      currencyId: "",
    }));

    const credentials2 = {
      UserGuid: loginData.userGuid,
      ClinicGuid: loginData.clinicGuid,
      CurrencyId: selected.value,
    }

    dispatch(actionDoctor.postUpdateDoctorFeesCurrency(credentials2, (error, response) => {
      if (error) {
        if (error.data) {
          if (error.data.statusCode === 400) {
            if (error.data.error && error.data.error.ValidationErrors) {
              error.data.error.ValidationErrors.forEach((validationError) => {
                console.error(
                  `${t("Field")}: ${validationError.Field} - ${t(
                    "Message"
                  )}: ${validationError.Message}`
                );

                showAlert(
                  "danger",
                  validationError.Message,
                  `${t("Error")} : ${validationError.Field}`
                );
              });
            } else {
              showAlert(
                "danger",
                `${t("Invalid_credentials")}`,
                `${t("Error")} !`
              );
            }
          } else {
            showAlert("danger", `${t("unexpected_error")}``${t("Error")} !`);
          }
        }
      } else if (response) {
        if (response.status === 200) {
          if (selectedDoctor?.value) {
            const clinicGuidToUse =
              loginData.userGuid === selectedDoctor.value
                ? null
                : loginData.clinicGuid;
            dispatch(
              actionDoctor.getFees(selectedDoctor.value, clinicGuidToUse)
            );
          }
          // showAlert("success", `change currency``${t("success")} !`);
        }
      }
    }))


  };

  useEffect(() => {
    dispatch(actionCommon.getCurrency());
    dispatch(actionDoctor.getClinicDoctorDetails(loginData.clinicGuid));
  }, [dispatch, loginData]);

  useEffect(() => {
    if (
      selectedDoctor?.value &&
      loginData?.clinicGuid &&
      selectedDoctor.value !== loginData.userGuid
    ) {
      dispatch(
        actionDoctor.getClinicDoctorServiceAndSchedule(
          selectedDoctor.value,
          loginData.clinicGuid
        )
      );
    }
  }, [dispatch, selectedDoctor?.value, loginData.clinicGuid, loginData.userGuid]);

  const getFeesData = useSelector((state) => state.doctor.getFeesData?.data);

  const getCurrencyData = useSelector(
    (state) => state.common.getCurrencyData?.data
  );
  const getClinicDoctorDetailsData = useSelector(
    (state) => state.doctor.getClinicDoctorDetailsData?.data
  );

  const getClinicDoctorServiceAndScheduleData = useSelector(
    (state) => state.doctor.getClinicDoctorServiceAndScheduleData?.data
  );

  const [options, setOptions] = useState([]);
  const [options1, setOptions1] = useState([]);

  const [selectedCurrency1, setSelectedCurrency1] = useState([]);

  useEffect(() => {
    if (selectedDoctor?.value) {
      const clinicGuidToUse =
        loginData.userGuid === selectedDoctor.value ? "" : loginData.clinicGuid;
      dispatch(actionDoctor.getFees(selectedDoctor.value, clinicGuidToUse));
    }
  }, [dispatch, selectedDoctor, loginData]);
  useEffect(() => {
    if (getClinicDoctorDetailsData) {
      const newOption = getClinicDoctorDetailsData.result.doctorLists.map(
        (item) => ({
          value: item.doctorGuid,
          label: item.doctorName,
        })
      );
      setOptions(newOption);

      const selectedDoctor = getClinicDoctorDetailsData.result.doctorLists.find(
        (doctor) => doctor.doctorGuid === loginData.userGuid
      );

      if (selectedDoctor) {
        setSelectedDoctor({
          value: selectedDoctor.doctorGuid,
          label: selectedDoctor.doctorName,
        });
      }
    }
  }, [getClinicDoctorDetailsData, loginData]);
  useEffect(() => {
    if (getCurrencyData) {
      const newOption = getCurrencyData.result.map((item) => ({
        value: item.currencyID,
        label: item.currency,
        currencyCode: item.currencyCode,
      }));
      setOptions1(newOption);
    }
  }, [getCurrencyData]);
  useEffect(() => {
    if (getFeesData) {
      const data = getFeesData.result;
      const selectedCurrency = options1.find(
        (option) => option.value === data.currencyId
      );

      setCredentials((prevCredentials) => ({
        ...prevCredentials,
        feesGuid: data.feesGuid,
        currencyId: selectedCurrency?.value || data.currencyId,
        onlineAppointmentFees: data.onlineAppointmentFees,
        refundPercentage: data.refundPercentage,
        inClinicAppointmentFees: data.inClinicAppointmentFees,
        refundInClinicPercentage: data.refundInClinicPercentage,
        isChatFree: data.isChatFree,
        chatFees: data.chatFees,
        currency: selectedCurrency?.label || data.currency,
        currencyCode: selectedCurrency?.currencyCode || data.currencyCode,
        acceptOnlinePayment: data.acceptOnlinePayment,
        commission: data.commission,
        oldCurrencyId: data.oldCurrencyId,
        isAutomaticBookingApproval: data.isAutomaticBookingApproval,
      }));

      setSelectedCurrency1(selectedCurrency);
    }
  }, [getFeesData, options1]);
  useEffect(() => {
    if (selectedDoctor?.value && selectedCurrency1?.currencyCode) {
      dispatch(
        actionDoctor.getAllAdditionalServices(
          selectedDoctor.value,
          selectedCurrency1.currencyCode
        )
      );
    }
  }, [dispatch, selectedDoctor, selectedCurrency1]);
  useEffect(() => {
    if (selectedCurrency1) {
      setCredentials1((prev) => ({
        ...prev,
        CurrencyCode: selectedCurrency1.currencyCode,
      }));
    }
  }, [selectedCurrency1]);
  const getAllAdditionalServicesData = useSelector(
    (state) => state.doctor.getAllAdditionalServicesData?.data
  );

  const handleAdd = () => {
    setCredentials1({
      doctorGuid: selectedDoctor?.value,
      serviceGuid: null,
      serviceName: "",
      description: "",
      amount: null,
      CurrencyCode: selectedCurrency1.value,
      vat: null,
    });
    setShowModal1(true);
  };
  const handleSave = () => {
    if (!selectedDoctor || !selectedDoctor.value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        physicianServiceIds: "Please select a doctor",
      }));
      return;
    }
    if (!selectedCurrency1 || !selectedCurrency1.value) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        currencyId: "Please select a currency",
      }));
      return;
    }

    // Calculate clinicGuidToUse BEFORE dispatch
    const clinicGuidToUse =
      loginData.userGuid === selectedDoctor.value ? null : loginData.clinicGuid;

    // Add clinicGuidToUse to credentials
    const updatedCredentials = {
      ...credentials,
      ClinicGuid: clinicGuidToUse,
    };

    console.log("credentials", updatedCredentials);

    dispatch(
      actionDoctor.saveFees(updatedCredentials, (error, response) => {
        if (error) {
          if (error.data) {
            if (error.data.statusCode === 400) {
              if (error.data.error && error.data.error.ValidationErrors) {
                error.data.error.ValidationErrors.forEach((validationError) => {
                  console.error(
                    `${t("Field")}: ${validationError.Field} - ${t(
                      "Message"
                    )}: ${validationError.Message}`
                  );

                  showAlert(
                    "danger",
                    validationError.Message,
                    `${t("Error")} : ${validationError.Field}`
                  );
                });
              } else {
                showAlert(
                  "danger",
                  `${t("Invalid_credentials")}`,
                  `${t("Error")} !`
                );
              }
            } else {
              showAlert("danger", `${t("unexpected_error")}`, `${t("Error")} !`);
            }
          }
        } else if (response) {
          if (response.status === 200) {
            if (selectedDoctor?.value) {
              dispatch(
                actionDoctor.getFees(selectedDoctor.value, clinicGuidToUse)
              );
            }
            showToast(
              t("success"),
              t("doctor.my_fees.success"),
              5000,
              true,
              "top-center toast-success"
            );
          }
        }
      })
    );
  };

  const rightSide = (
    <Container fluid className="exado-container1">
      <Row className="exado-row1">
        <Col>
          <Header.HeadingPage pageHeading={t("Fees")} />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <div className="my-fees-form-blk">
            <Form className="my-fees-form">
              <Row className="fees-row">
                <Col>
                  <Form.Label className="exado-title-six">
                    {t("Select") + " " + t("doctor.doctor")}
                  </Form.Label>

                  <SelectO.SelectO
                    options={options}
                    onChange={handleSelectChange}
                    isSearchable={false}
                    name="physicianServiceIds"
                    value={selectedDoctor}
                    className={`select1 ${errors.physicianServiceIds ? "select-border-error" : ""
                      }`}
                    placeholder={t("Select") + " " + t("doctor.doctor")}
                  />
                  {errors.physicianServiceIds && (
                    <Form.Text className="error-message noVerify">
                      {errors.physicianServiceIds}
                    </Form.Text>
                  )}
                </Col>
                <Col>
                  <Form.Label className="exado-title-six">
                    {t("Select") + " " + t("currency")}
                  </Form.Label>

                  <SelectO.SelectO
                    options={options1}
                    onChange={(selected) =>
                      handleSelectChange1("currencyId", selected)
                    }
                    // isMulti={true}
                    isSearchable={false}
                    name="currencyId"
                    value={selectedCurrency1}
                    className={`select1 ${errors.currencyId ? "select-border-error" : ""
                      }`}
                    placeholder={t("Select") + " " + t("currency")}
                    isDisabled={loginData?.userGuid !== selectedDoctor?.value}
                  />
                  {errors.currencyId && ( // Check for currencyId errors
                    <Form.Text className="error-message noVerify">
                      {errors.currencyId}
                    </Form.Text>
                  )}
                </Col>
              </Row>
              <Row className="fees-row">
                <Form.Label className="exado-title-six">
                  {t("doctor.my_fees.online_appointment")}
                </Form.Label>
                <Col md={6}>
                  <Row>
                    <Inputs.FormInputs
                      label={
                        selectedCurrency1?.currencyCode
                          ? `${selectedCurrency1.currencyCode} ${t("doctor.my_fees.per_consultation")}`
                          : `${t("currency")} ${t("doctor.my_fees.per_consultation")}`
                      }
                      value={credentials.onlineAppointmentFees || ""}
                      name="onlineAppointmentFees"
                      onChange={handleDecimalChange}
                      grpClassname="form-group"
                    // disabled={!isEditVisible}
                    />
                  </Row>
                </Col>
                <Col md={12} className="fees-col">
                  <Form.Label className="exado-title-ten">
                    {t("doctor.my_fees.refund_question")}
                  </Form.Label>
                  <div className="d-flex justify-content-between align-items-center">
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="0%"
                      name="refundPercentage"
                      className="form-grp-radio"
                      checked={credentials.refundPercentage === 0}
                      onChange={() =>
                        setCredentials({ ...credentials, refundPercentage: 0 })
                      }
                    // disabled={!isEditVisible}
                    />
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="25%"
                      name="refundPercentage"
                      className="form-grp-radio"
                      checked={credentials.refundPercentage === 25}
                      onChange={() =>
                        setCredentials({ ...credentials, refundPercentage: 25 })
                      }
                    // disabled={!isEditVisible}
                    />
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="50%"
                      name="refundPercentage"
                      className="form-grp-radio"
                      checked={credentials.refundPercentage === 50}
                      onChange={() =>
                        setCredentials({ ...credentials, refundPercentage: 50 })
                      }
                    // disabled={!isEditVisible}
                    />
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="75%"
                      name="refundPercentage"
                      className="form-grp-radio"
                      checked={credentials.refundPercentage === 75}
                      onChange={() =>
                        setCredentials({ ...credentials, refundPercentage: 75 })
                      }
                    // disabled={!isEditVisible}
                    />
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="100%"
                      name="refundPercentage"
                      className="form-grp-radio"
                      checked={credentials.refundPercentage === 100}
                      onChange={() =>
                        setCredentials({
                          ...credentials,
                          refundPercentage: 100,
                        })
                      }
                    // disabled={!isEditVisible}
                    />
                  </div>
                </Col>
              </Row>
              <Row className="fees-row">
                <Form.Label className="exado-title-six">
                  {t("doctor.my_fees.in_clinic_appointment")}
                </Form.Label>
                <Col md={6}>
                  <Row>
                    <Inputs.FormInputs
                      label={
                        selectedCurrency1?.currencyCode
                          ? `${selectedCurrency1.currencyCode} ${t("doctor.my_fees.per_consultation")}`
                          : `${t("currency")} ${t("doctor.my_fees.per_consultation")}`
                      }
                      value={credentials.inClinicAppointmentFees}
                      name="inClinicAppointmentFees"
                      onChange={handleDecimalChange}
                      grpClassname="form-group"
                    />
                  </Row>
                </Col>
                <Col md={12} className="fees-col">
                  <Inputs.CheckRadioInput
                    name="acceptOnlinePayment"
                    checked={credentials.acceptOnlinePayment}
                    label={t("doctor.my_fees.accept_online_payment")}
                    onChange={(e) => {
                      const isChecked = e.target.checked;

                      setCredentials({
                        ...credentials,
                        acceptOnlinePayment: isChecked,

                        refundInClinicPercentage: isChecked
                          ? credentials.refundInClinicPercentage
                          : 0,
                      });
                    }}
                    className="form-grp-check"
                  // disabled={!isEditVisible}
                  />

                  {credentials.acceptOnlinePayment && (
                    <>
                      <Form.Label className="exado-title-ten">
                        {t("doctor.my_fees.refund_question")}
                      </Form.Label>

                      <div className="d-flex justify-content-between align-items-center">
                        <Inputs.CheckRadioInput
                          type="radio"
                          label="0%"
                          name="refundInClinicPercentage"
                          className="form-grp-radio"
                          checked={credentials.refundInClinicPercentage === 0}
                          onChange={() =>
                            setCredentials({
                              ...credentials,
                              refundInClinicPercentage: 0,
                            })
                          }
                        />
                        <Inputs.CheckRadioInput
                          type="radio"
                          label="25%"
                          name="refundInClinicPercentage"
                          className="form-grp-radio"
                          checked={credentials.refundInClinicPercentage === 25}
                          onChange={() =>
                            setCredentials({
                              ...credentials,
                              refundInClinicPercentage: 25,
                            })
                          }
                        />
                        <Inputs.CheckRadioInput
                          type="radio"
                          label="50%"
                          name="refundInClinicPercentage"
                          className="form-grp-radio"
                          checked={credentials.refundInClinicPercentage === 50}
                          onChange={() =>
                            setCredentials({
                              ...credentials,
                              refundInClinicPercentage: 50,
                            })
                          }
                        />
                        <Inputs.CheckRadioInput
                          type="radio"
                          label="75%"
                          name="refundInClinicPercentage"
                          className="form-grp-radio"
                          checked={credentials.refundInClinicPercentage === 75}
                          onChange={() =>
                            setCredentials({
                              ...credentials,
                              refundInClinicPercentage: 75,
                            })
                          }
                        />
                        <Inputs.CheckRadioInput
                          type="radio"
                          label="100%"
                          name="refundInClinicPercentage"
                          className="form-grp-radio"
                          checked={credentials.refundInClinicPercentage === 100}
                          onChange={() =>
                            setCredentials({
                              ...credentials,
                              refundInClinicPercentage: 100,
                            })
                          }
                        />
                      </div>
                    </>
                  )}
                </Col>
              </Row>
              <Row className="fees-row">
                <Form.Label className="exado-title-six">
                  {t("doctor.my_fees.chat_consultation")}
                </Form.Label>

                <Col md={6}>
                  <Form.Label className="exado-title-ten">
                    {t("doctor.my_fees.free_chat_question")}
                  </Form.Label>

                  <div className="form-grp-radio-blk">
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="yes"
                      name="isChatFree"
                      className="form-grp-radio"
                      checked={credentials.isChatFree === true}
                      onChange={() =>
                        setCredentials({ ...credentials, isChatFree: true })
                      }
                    // disabled={!isEditVisible}
                    />
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="no"
                      name="isChatFree"
                      className="form-grp-radio"
                      checked={credentials.isChatFree === false}
                      onChange={() =>
                        setCredentials({ ...credentials, isChatFree: false })
                      }
                    // disabled={!isEditVisible}
                    />
                  </div>
                </Col>
                {credentials.isChatFree === false && (
                  <Col md={6}>
                    <Row>
                      <Inputs.FormInputs
                        label={
                          selectedCurrency1?.currencyCode
                            ? `${selectedCurrency1.currencyCode} ${t("doctor.my_fees.per_consultation")}`
                            : `${t("currency")} ${t("doctor.my_fees.per_consultation")}`
                        }
                        value={credentials.chatFees}
                        name="chatFees"
                        onChange={handleDecimalChange}
                        grpClassname="form-group"
                      // disabled={!isEditVisible}
                      />
                    </Row>
                  </Col>
                )}
              </Row>
              <Row className="fees-row">
                <Form.Label className="exado-title-six">
                  {t("doctor.my_fees.automatic_booking_approval")}
                </Form.Label>

                <Col md={6}>
                  <Form.Label className="exado-title-ten">
                    {t("doctor.my_fees.automatic_booking_approval_question")}
                  </Form.Label>

                  <div className="form-grp-radio-blk">
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="yes"
                      name="isAutomaticBookingApproval"
                      className="form-grp-radio"
                      // checked={credentials.isChatFree === true}
                      checked={credentials.isAutomaticBookingApproval === true}
                      onChange={() =>
                        setCredentials({
                          ...credentials,
                          isAutomaticBookingApproval: true,
                        })
                      }
                    // disabled={!isEditVisible}
                    />
                    <Inputs.CheckRadioInput
                      type="radio"
                      label="no"
                      name="isAutomaticBookingApproval"
                      className="form-grp-radio"
                      // checked={credentials.gender === 1}
                      checked={credentials.isAutomaticBookingApproval === false}
                      onChange={() =>
                        setCredentials({
                          ...credentials,
                          isAutomaticBookingApproval: false,
                        })
                      }
                    // disabled={!isEditVisible}
                    />
                  </div>
                </Col>
              </Row>
            </Form>
            <div className="profile-form-btn-blk">
              <Buttton.Buttton
                children={t("save")}
                className=" btn-solid-Aqua_Teal"
                onClick={handleSave}
              // disabled={!isEditVisible}
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <Header.HeadingPage
            pageHeading={t("additional_services")}
            buttons={
              selectedDoctor?.value === loginData?.userGuid && (
                <Buttton.Buttton
                  className="btn-solid-Aqua_Teal"
                  children={`${t("add")} +`}
                  onClick={handleAdd}
                />
              )
            }
          />
        </Col>
      </Row>
      <Row className="exado-row1">
        <Col>
          <Tabbles.TableBlk
            headerIcon={<MdOutlineMedicalServices className="header-Icn" />}
            heading={t("additional_services")}
            subHeading=""
            columns={[
              `${t("Services")}`,
              `${t("description")}`,
              `${t("amount")}`,
              "Vat%",
              `${t("Edit")}`,
              `${t("delete")}`,

            ]}
            data={
              selectedDoctor?.value !== loginData?.userGuid
                ? getClinicDoctorServiceAndScheduleData?.result?.additionalService?.map((service) => ({
                  [t("Services")]: service.clinicDoctorAdditionalServiceName,
                  [t("description")]: service.description,
                  [t("amount")]: `${service.amount} ${service.currencyCode}`,
                  "Vat%": `${service.vat} %`,
                  [t("Edit")]: "-",
                  [t("delete")]: "-",
                }))
                : getAllAdditionalServicesData?.result?.map((service) => ({
                  [t("Services")]: service.serviceName,
                  [t("description")]: service.description,
                  [t("amount")]: `${service.amount} ${service.currencyCode}`,
                  "Vat%": `${service.vat} %`,
                  [t("Edit")]: (
                    <div className="editBlkIcon">
                      <FiEdit
                        onClick={() => handleEdit(service)}
                        className="editIcon"
                      />
                    </div>
                  ),
                  [t("delete")]: (
                    <PiTrash
                      onClick={() => handleDeleteService(service.serviceGuid)}
                      className="delIcon noVerify"
                    />
                  ),
                }))
            }

            tabbleClassname="tabble"
          />
        </Col>
      </Row>
    </Container>
  );

  const [credentials1, setCredentials1] = useState({
    doctorGuid: loginData.userGuid,
    serviceGuid: null,
    serviceName: "",
    description: "",
    amount: null,
    CurrencyCode: credentials.currencyCode,
    vat: null,
  });

  const [errors1, setErrors1] = useState({});

  const [showModal1, setShowModal1] = useState(false);
  const handleCloseModal = () => {
    setErrors1({});
    setShowModal1(false);
  };
  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setCredentials1((prevState) => ({
      ...prevState,
      [name]:
        name === "amount" || name === "vat"
          ? value
            ? parseFloat(value)
            : null
          : value,
    }));
  };

  const handleEdit = (service) => {
    setCredentials1({
      doctorGuid: service.doctorGuid,
      serviceGuid: service.serviceGuid,
      serviceName: service.serviceName,
      description: service.description,
      amount: service.amount,
      CurrencyCode: service.currencyCode,
      vat: service.vat,
    });
    setShowModal1(true);
  };
  // const validate = () => {
  //   const newErrors = {};

  //   if (!credentials.physicianServiceIds) {
  //     newErrors.physicianServiceIds = "Please select a doctor.";
  //   }

  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };
  const handleSubmit = () => {
    const validationErrors = validateCredentials1(credentials1);

    if (Object.keys(validationErrors).length > 0) {
      setErrors1(validationErrors);
      return;
    }

    const formattedCredentials = {
      ...credentials1,
      amount: credentials1.amount !== null ? Number(credentials1.amount) : null,
      vat: credentials1.vat !== null ? Number(credentials1.vat) : null,
    };
    dispatch(
      actionDoctor.saveAdditionalServiceInfo(
        formattedCredentials,
        (error, response) => {
          if (error) {
            if (error.data) {
              if (error.data.statusCode === 400) {
                if (error.data.error && error.data.error.ValidationErrors) {
                  error.data.error.ValidationErrors.forEach(
                    (validationError) => {
                      console.error(
                        `${t("Field")}: ${validationError.Field} - ${t(
                          "Message"
                        )}: ${validationError.Message}`
                      );

                      showAlert(
                        "danger",
                        validationError.Message,
                        `${t("Error")} : ${validationError.Field}`
                      );
                    }
                  );
                } else {
                  showAlert(
                    "danger",
                    `${t("Invalid_credentials")}`,
                    `${t("Error")} !`
                  );
                }
              } else {
                showAlert(
                  "danger",
                  `${t("unexpected_error")}``${t("Error")} !`
                );
              }
            }
          } else if (response) {
            if (response.status === 200) {
              dispatch(
                actionDoctor.getAllAdditionalServices(
                  loginData.userGuid,
                  selectedCurrency1?.currencyCode
                )
              );




              showToast(
                t("success"),
                t("additional_services_success"),
                5000,
                true,
                "top-center toast-success"
              );
            }
          }
        }
      )
    );
  };
  const validateCredentials1 = (data) => {
    const errors1 = {};

    if (!data.serviceName) {
      errors1.serviceName = "Service Name is required.";
    }
    if (!data.description || data.description.trim() === "") {
      errors1.description = "Description is required.";
    }

    if (!data.amount || isNaN(data.amount)) {
      errors1.amount = "Amount must be a valid number.";
    }

    if (data.vat !== null && data.vat !== "" && isNaN(data.vat)) {
      errors1.vat = "VAT must be a valid number.";
    }

    return errors1;
  };
  const handleDeleteService = (serviceGuid) => {
    showModal({
      title: <h2 className="exado-title-nine">{t("doctor.my_fees.delete_additional_service")}</h2>,
      bodyContent: <TbInfoTriangleFilled className="info-triangle-icon" />,
      bodyContent1: (
        <p className="exado-title-six">
          {" "}
          {t("doctor.my_fees.confirm_delete_additional_service")}
        </p>
      ),
      // autoClose: 5000,
      footer: (
        <>
          <Buttton.Buttton
            children="Cancel"
            className="btn-border-Aqua_Teal"
            onClick={hideModal}
          />
          <Buttton.Buttton
            children="Delete"
            className="btn-solid-Carmine_red"
            onClick={() => {
              hideModal();

              dispatch(
                actionDoctor.deleteServiceById(
                  serviceGuid,
                  (error, response) => {
                    if (error) {
                      if (error.data) {
                        if (error.data.statusCode === 400) {
                          if (
                            error.data.error &&
                            error.data.error.ValidationErrors
                          ) {
                            error.data.error.ValidationErrors.forEach(
                              (validationError) => {
                                console.error(
                                  `${t("Field")}: ${validationError.Field
                                  } - ${t("Message")}: ${validationError.Message
                                  }`
                                );

                                showAlert(
                                  "danger",
                                  validationError.Message,
                                  `${t("Error")} : ${validationError.Field}`
                                );
                              }
                            );
                          } else {
                            showAlert(
                              "danger",
                              `${t("Invalid_credentials")}`,
                              `${t("Error")} !`
                            );
                          }
                        } else {
                          showAlert(
                            "danger",
                            `${t("unexpected_error")}``${t("Error")} !`
                          );
                        }
                      }
                    } else if (response) {
                      if (response.status === 200) {
                        dispatch(
                          actionDoctor.getAllAdditionalServices(
                            loginData.userGuid,
                            selectedCurrency1?.currencyCode
                          )
                        );
                        showSnackBar(
                          t("visiting_schedule.services_deleted"),
                          "snackbar-success"
                        );
                      }
                    }
                  }
                )
              );
            }}
          />
        </>
      ),
      className: "del-modal",
    });
  };

  return (
    <>
      <AppLayout.AppLayoutOne
        leftSide={<Sides.LeftSides loginData={loginData} />}
        rightSide={rightSide}
      />
      <Modaal.Modaal
        show={showModal1}
        onHide={handleCloseModal}
        centered="true"
        title={
          <h2 className="exado-title-nine">
            {credentials1.serviceGuid ? t("edit_service") : t("add_new_service")}
          </h2>
        }
        bodyContent={
          <Form className="my-fees-form">
            <Row className="fees-row">
              <Col md={6} className="fees-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors1.serviceName ? (
                        <span className="error-message">
                          {errors1.serviceName}
                        </span>
                      ) : (
                        t("service_name")
                      )
                    }
                    value={credentials1.serviceName}
                    name="serviceName"
                    onChange={handleChange1}
                    grpClassname={`form-group ${errors1.serviceName ? "form-group-error" : ""
                      }`}
                  />
                </Row>
              </Col>
              <Col md={6} className="fees-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors1.description ? (
                        <span className="error-message">
                          {errors1.description}
                        </span>
                      ) : (
                        t("description")
                      )
                    }
                    value={credentials1.description}
                    name="description"
                    onChange={handleChange1}
                    grpClassname={`form-group ${errors1.description ? "form-group-error" : ""
                      }`}
                  />
                </Row>
              </Col>
              <Col md={6} className="fees-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors1.amount ? (
                        <span className="error-message">{errors1.amount}</span>
                      ) : (
                        t("amount")
                      )
                    }
                    value={credentials1.amount || ""}
                    name="amount"
                    onChange={handleChange1}
                    grpClassname={`form-group ${errors1.amount ? "form-group-error" : ""
                      }`}
                  />
                </Row>
              </Col>
              <Col md={6} className="fees-col">
                <Row>
                  <Inputs.FormInputs
                    label={
                      errors1.vat ? (
                        <span className="error-message">{errors1.vat}</span>
                      ) : (
                        "VAT%"
                      )
                    }
                    value={credentials1.vat || ""}
                    name="vat"
                    onChange={handleChange1}
                    grpClassname={`form-group ${errors1.vat ? "form-group-error" : ""
                      }`}
                  />
                </Row>
              </Col>
            </Row>
          </Form>
        }
        footer={
          <Buttton.Buttton
            children={t("SUBMIT")}
            className="btn-solid-Aqua_Teal"
            onClick={handleSubmit}
          />
        }
        backdrop="static"
        className="input-modal my-fees-modal"
      />
    </>
  );
};

export default MyFees;
